import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["orientation", "wrapItems"];
import memoize from 'react-utils/memoize';
import styled, { css } from 'foundations-theming/utils';
import { WellContextProvider } from './WellContext';
import { useMapTokenPropsToCSS } from '../../../hooks/useMapTokenPropsToCSS';
import { filterTokenProps } from '../../../utils/filterTokenProps';
import { jsx as _jsx } from "react/jsx-runtime";
const getContextValue = memoize(orientation => {
  return {
    WellItemComponent: 'li',
    orientation: orientation
  };
});
const wrapItemsMixin = css(["flex-wrap:wrap;display:grid;grid-template-columns:repeat(auto-fit,minmax(180px,1fr));"]);
const verticalMixin = css(["display:flex;flex-direction:column;"]);
const List = styled.ul.withConfig({
  displayName: "Well__List",
  componentId: "ao3nz9-0"
})(({
  theme,
  $wrapItems,
  $orientation,
  $cssStyles
}) => {
  return css(["display:flex;justify-content:space-around;list-style-type:none;margin:", ";padding-top:", ";padding-left:", ";", ";", ";", ""], theme.space['0'], theme.space['800'], theme.space['300'], $wrapItems && wrapItemsMixin, $orientation === 'vertical' && verticalMixin, $cssStyles);
});
export const Well = _ref => {
  let {
      orientation = 'horizontal',
      wrapItems = true
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    tokenProps,
    restProps
  } = filterTokenProps(rest);
  const cssStyles = useMapTokenPropsToCSS(tokenProps);
  return /*#__PURE__*/_jsx(WellContextProvider, {
    value: getContextValue(orientation),
    children: /*#__PURE__*/_jsx(List, Object.assign({}, restProps, {
      $cssStyles: cssStyles,
      $orientation: orientation,
      $wrapItems: wrapItems
    }))
  });
};